
import config from '../config/config'
import utils from '../utils/commonUtils'
import constants from './constants'
import '../api/sso/sso'
import handleResult from './handleResult';

export default {
  data() {
    return {
      env_name: ENV_NAME
    };
  },
  isInit: false,

  //path :'/task/classwork/create'
  //groupId:'b6dea5e3dfd2420fae6fee0cb845f246'
  requestMethod(param, path, groupId) {
    var self = this;
    if (!self.isInit) {
      let apiConfig = Object.assign({}, config.getConfig().apiConfig);
      shield.ShieldConfig.config(apiConfig);
      // // 配置初始化
      shield.ShieldConfig.init();
      this.isInit = true;
    }
    // 创建请求参数
    var params = new shield.ParamsBuilder({
      scheme: ENV_NAME === 'production' ? shield.HttpConstant.SCHEME_HTTPS : shield.HttpConstant.SCHEME_HTTP,
      method: shield.Method.POST,
      path: config.getConfig().apiConfig.prefixPath + path,
      authType: shield.SdkConstant.AUTH_TYPE_DEFAULT,
      groupId: groupId,
    })
    if (!!param) {
      params.addParam("param", JSON.stringify(param), shield.ParamPosition.FORM, false);
    }
    let token = sessionStorage.getItem('token');
    //let mac = sessionStorage.getItem('mac');
    let rolecode = sessionStorage.getItem('rolecode');
    let deviceId = SSO.deviceId;

    let extInfoStr = this.getExtInfo(deviceId, rolecode);
    params.addParam("S-Auth-Token", token, shield.ParamPosition.HEADER, true);
    params.addParam("S-Auth-ClientType", config.getConfig().ssoConfig.client, shield.ParamPosition.HEADER, true);
    params.addParam("S-Auth-DeviceId", deviceId, shield.ParamPosition.HEADER, true);
    //params.addParam("S-Auth-Mac", mac, shield.ParamPosition.HEADER, true);
    //params.addParam("S-Auth-ClientIp", '192.168.1.100', shield.ParamPosition.HEADER, true);
    params.addParam("S-Auth-ExtInfo", extInfoStr, shield.ParamPosition.HEADER, true);
    // http请求
    return new Promise((resolve, reject) => {
      shield.request(params).then(res => {
        resolve(res);
      }, res => handleResult.doError(res, reject));
    });
  },
  getExtInfo(deviceId, rolecode) {
    let extInfoStr = utils.stringFormat("deviceId:{0};roleCode:{1}", [deviceId, rolecode]);
    return extInfoStr;
  }
}






// WEBPACK FOOTER //
// ./src/common/request.js